import React, {ReactNode} from "react";
import {TooltipPlacement} from "antd/es/tooltip";
import {Popover} from "antd";
import {TooltipContent} from "../themes/SharedStyledComponent";

export const wrapWithPopover = (
  trigger: ReactNode,
  content: ReactNode,
  placement?: TooltipPlacement,) => {
  return <Popover {...{
    placement,
    content: <TooltipContent>{content}</TooltipContent>,
    mouseEnterDelay: 0.5,
    arrow: {pointAtCenter: true},
    autoAdjustOverflow: true,
  }}>{
    trigger
  }</Popover>
}